import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminlistados-socios-crear',
  templateUrl: './adminlistados-socios-crear.component.html',
  styleUrls: ['./adminlistados-socios-crear.component.scss']
})
export class AdminlistadosSociosCrearComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/adminlistados-socios-crear/adminlistados-socios-crear.component.ts